module.exports = __webpack_public_path__ + "img/sanqi1.244fc64a.png";